import React from "react";
import Label from "@components/Label";
import { StyledTextArea } from "./Textarea.styled";
import { ErrorMessage } from "@styles/typography";

const Textarea = ({
  disabled,
  label,
  isreadonly,
  fluid,
  labelPosition = "top",
  labelFontSize,
  labelWeight,
  uppercase,
  formik,
  name,
  onBlur,
  minRows = 3,
  ...otherProps
}) => {
  const meta = formik && formik.getFieldMeta(name);
  const hasError = meta && meta.touched && meta.error;

  return (
    <>
      <Label
        position={labelPosition}
        title={label}
        fluid={fluid}
        disabled={disabled}
        labelFontSize={labelFontSize}
        labelWeight={labelWeight}
        uppercase={uppercase}>
        <StyledTextArea
          minRows={minRows}
          isreadonly={isreadonly ? 1 : 0}
          disabled={disabled}
          onBlur={() => (formik ? formik.setFieldTouched(name, true) : onBlur)}
          {...otherProps}
        />
      </Label>

      {hasError && <ErrorMessage position={labelPosition}>{meta.error}</ErrorMessage>}
    </>
  );
};

export default Textarea;
